<div
  class="map-grid"
  [class.grid-gap]="splitLayoutConf.isEnable && (splitLayoutConf.halfScreen || splitLayoutConf.collapsed)"
  [class.full-size-view]="!splitLayoutConf.halfScreen"
  [class.collapsed-view]="splitLayoutConf.collapsed"
>
  <ebw-monorepo-split-portal *ngIf="splitLayoutConf.isEnable" [@bubbleGrow]></ebw-monorepo-split-portal>

  <div class="rounded-container">
    <map-component
      *ngIf="mapConfig"
      #mapview
      [mapConfiguration]="mapConfig"
      [externalToolbar]="true"
      (changeActivePreviewHandler)="changeActivePreview($event)"
    ></map-component>
  </div>
</div>
